"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyClient = void 0;
const api_1 = require("../core/api");
/**
 * Client that contains taxonomy related operations
 */
class TaxonomyClient {
    constructor(config) {
        this.config = config;
        this.api = new api_1.ApiService(config);
    }
    /**
     * Fetch taxonomy by id
     * @param id @type string
     */
    findTaxonomy(id) {
        const { api } = this;
        return api.get(["taxonomies", id]);
    }
    /**
     * Fetch taxonomy in the for of a tree
     * @param id @type string
     */
    findTaxonomyTree(id) {
        const { api } = this;
        return api.get(["taxonomies", id, "tree"]);
    }
    /**
     * Fetch taxonomies
     * @param query @type Query
     */
    findTaxonomies(query) {
        const { api } = this;
        return api.get(["taxonomies"], query);
    }
    /**
     * Create new taxonomy
     * @param body @type Taxonomy
     */
    createTaxonomy(body) {
        const { api } = this;
        return api.post(["taxonomies"], body);
    }
    /**
     * Update taxonomy
     * @param id @type string
     * @param body @type Taxonomy
     */
    updateTaxonomy(id, body) {
        const { api } = this;
        return api.put(["taxonomies", id], body);
    }
    /**
     * Delete taxonomy
     * @param id @type string
     */
    destroyTaxonomy(id) {
        const { api } = this;
        return api.delete(["taxonomies", id]);
    }
    /**
     * Create new taxonomy entry
     * @param taxonomyId @type string
     * @param body @type TaxonomyEntry
     */
    createTaxonomyEntry(taxonomyId, body) {
        const { api } = this;
        return api.post(["taxonomies", taxonomyId, "entries"], body);
    }
    /**
     * Delete taxonomy entry
     * @param taxonomyId @type string
     * @param entryId @type string
     */
    destroyTaxonomyEntry(taxonomyId, entryId) {
        const { api } = this;
        return api.delete(["taxonomies", taxonomyId, "entries", entryId]);
    }
    /**
     * Move taxonomy entry position in hierarchy
     * @param taxonomyId @type string
     * @param entryId @type string
     * @param body @type TaxonomyEntryMovement
     */
    moveTaxonomyEntry(taxonomyId, entryId, body) {
        const { api } = this;
        return api.put(["taxonomies", taxonomyId, "entries", entryId], body);
    }
}
exports.TaxonomyClient = TaxonomyClient;
//# sourceMappingURL=taxonomy.client.js.map